export default __webpack_public_path__ + "static/media/bannerFeiraoCarnavalWorker.3879af03.png";